<template>
  <div>
    <!-- list -->
    <div v-if="!showModal" class="p-6 pt-0">
      <div class="gurudwara-quick-cards hotel-quick-cards" :style="{ '--quick-card-count': hotelQuickCards.length }">
        <button
          v-for="card in hotelQuickCards"
          :key="card.key"
          type="button"
          class="gurudwara-quick-card"
          @click="openHotelQuickCard(card)"
        >
          <span class="gurudwara-quick-card-count">{{ card.count }}</span>
          <span class="gurudwara-quick-card-copy">
            <span class="gurudwara-quick-card-label">{{ card.label }}</span>
            <feather-icon icon="ChevronRightIcon" svgClasses="w-5 h-5 stroke-current" />
          </span>
        </button>
      </div>
      <vs-table id="hotel-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
        @search="updateSearchQuery" @change-page="handleChangePage" @sort="handleSort" :total="FilteredCount"
        :max-items="length" search :data="records">
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }} -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }} of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)"><span>10</span></vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)"><span>20</span></vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)"><span>50</span></vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)"><span>100</span></vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
              <div class="flex flex-wrap items-center">
                <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages"
                  :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
              </div>
              <vs-button @click="viewBookings" color="dark" size="default"
                style="padding: 12px 30px; margin-right: 10px">
                View Booking
              </vs-button>
              <vs-button @click="createBooking" color="dark" size="default"
                style="padding: 12px 30px; margin-right: 10px">
                New Booking
              </vs-button>
              <vs-button @click="toggleAddModal" color="primary" size="default" style="padding: 12px 30px">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add Hotel
              </vs-button>
              <vs-button style="padding: 12px 30px; margin-left: 10px" icon-pack="feather" icon="icon-refresh-ccw"
                @click="refreshData" class="mr-2">Refresh</vs-button>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Hotel Name</vs-th>
          <vs-th>Rooms</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>View</vs-th>
          <vs-th>Dashboard</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>{{ page * length - (length - i - 1) }}</vs-td>
            <vs-td class="text-left">
              <span class="cursor-pointer" @click.stop="toggleEditModal(tr)">{{ tr.name || '-' }}</span>
            </vs-td>
            <vs-td>
              <span>{{ (tr.rooms && tr.rooms.length) || 0 }} rooms</span>
            </vs-td>
            <vs-td>
              <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary"
                :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
            </vs-td>
            <vs-td>
              <vx-tooltip text="View details">
                <feather-icon @click.stop="openHotelDetails(tr)" icon="EyeIcon"
                  svgClasses="h-6 w-6 hover:text-primary cursor-pointer" />
              </vx-tooltip>
            </vs-td>
            <vs-td>
              <vx-tooltip text="Hotel dashboard">
                <feather-icon @click.stop="viewDashboard(tr)" icon="BarChart2Icon"
                  svgClasses="h-6 w-6 hover:text-primary cursor-pointer" />
              </vx-tooltip>
            </vs-td>
            <vs-td>
              <div class="inline-flex">
                <vx-tooltip text="Edit Hotel">
                  <feather-icon @click.stop="toggleEditModal(tr)" icon="EditIcon"
                    svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip text="Delete Hotel">
                  <feather-icon @click.stop="deleteRecord(tr)" icon="TrashIcon"
                    svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip text="Manage Managers">
                  <feather-icon @click.stop="manageManagers(tr)" icon="UsersIcon"
                    svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- Add/Edit Modal (Action Page) -->
    <action-modal v-if="showModal" :hotel-id="selectedRecordId" :is-edit-mode="isEditModalShow" @close="closeModal"
      @saved="closeModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from '@/axios'
import ActionModal from './action.vue'

export default {
  name: 'HotelList',
  components: {
    'action-modal': ActionModal
  },
  props: {
    gurudwaraId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      records: [],
      FilteredCount: 0,
      total: 0,
      page: 1,
      length: 10,
      searchQuery: '',
      isAddModalShow: false,
      isEditModalShow: false,
      isAddModalMounted: false,
      isEditModalMounted: false,
      selectedRecordId: null,
      selectedRecordData: null,
      deletingRecord: null
    }
  },
  computed: {
    ...mapState('adminNotifications', ['quickCounts']),
    hotelQuickCards() {
      const counts = this.quickCounts || {}
      return [{ key: 'hotel', count: counts.hotel || 0, label: 'New Hotel Bookings', kind: 'hotel' }]
    },
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    },
    showModal: {
      get() {
        return this.isAddModalShow || this.isEditModalShow
      },
      set(value) {
        if (!value) {
          this.isAddModalShow = false
          this.isEditModalShow = false
        }
      }
    }
  },
  watch: {
    page() {
      this.getData()
    }
  },
  mounted() {
    this.getData()
    this.$store.dispatch('adminNotifications/fetchQuickCounts')
  },
  methods: {
    async getData() {
      try {
        const params = {
          page: this.page,
          limit: this.length,
          search: this.searchQuery
        }
        const response = await axios.get('/admin/hotel', { params })
        if (response.data.success) {
          this.records = response.data.data.results || []
          this.FilteredCount = response.data.data.totalResults || 0
          this.total = response.data.data.totalResults || 0
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to fetch hotel list',
          color: 'danger'
        })
      }
    },
    async refreshData() {
      try {
        this.page = 1
        await this.getData()
        this.$vs.notify({
          title: 'Success',
          text: 'Data refreshed successfully',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        })
      } catch (error) {
        console.error('Refresh error:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to refresh data',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      }
    },
    openHotelQuickCard(card) {
      if (!card || card.kind !== 'hotel') return
      const query = { from: 'list', focus: 'pending', open: String(Date.now()) }
      if (this.gurudwaraId) {
        this.$router.push({ path: `/gurudwara/${this.gurudwaraId}/hotel/bookings`, query }).catch(() => {})
      } else {
        this.$router.push({ path: '/hotel/bookings', query }).catch(() => {})
      }
    },
    viewBookings() {
      if (this.gurudwaraId) {
        this.$router.push(`/gurudwara/${this.gurudwaraId}/hotel/bookings`)
      } else {
        this.$router.push('/hotel/bookings')
      }
    },
    createBooking() {
      if (this.gurudwaraId) {
        this.$router.push(`/gurudwara/${this.gurudwaraId}/hotel/bookings?newBooking=1`)
      } else {
        this.$router.push('/hotel/bookings?newBooking=1')
      }
    },
    openHotelDetails(hotel) {
      if (this.gurudwaraId) {
        this.$router.push(`/gurudwara/${this.gurudwaraId}/hotel/${hotel._id}/view`)
      } else {
        this.$router.push(`/hotel/view/${hotel._id}`)
      }
    },
    viewDashboard(hotel) {
      const id = hotel && hotel._id != null ? String(hotel._id) : ''
      if (!id) return
      if (this.gurudwaraId) {
        this.$router.push(`/gurudwara/${this.gurudwaraId}/hotel/${id}/dashboard`)
      } else {
        this.$router.push(`/hotel/${id}/dashboard`)
      }
    },
    manageManagers(hotel) {
      if (this.gurudwaraId) {
        this.$router.push(`/gurudwara/${this.gurudwaraId}/hotel/${hotel._id}/managers`)
      } else {
        this.$router.push(`/hotel/${hotel._id}/managers`)
      }
    },
    updateSearchQuery(query) {
      this.searchQuery = query
      this.page = 1
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleChangeLength(length) {
      this.length = length
      this.page = 1
      this.getData()
    },
    handleSort(key, active) {
      // Handle sorting if needed
      this.getData()
    },
    toggleAddModal() {
      this.isAddModalMounted = true
      this.isAddModalShow = true
      this.selectedRecordId = null
      this.selectedRecordData = null
    },
    toggleEditModal(record) {
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecordId = record._id != null ? String(record._id) : null
      this.selectedRecordData = record
    },
    closeModal() {
      this.isAddModalShow = false
      this.isEditModalShow = false
      this.isAddModalMounted = false
      this.isEditModalMounted = false
      this.selectedRecordId = null
      this.selectedRecordData = null
      this.getData()
    },
    async updateStatus(id, status) {
      try {
        await axios.put(`/admin/hotel/${id}`, { is_active: status })
        this.$vs.notify({
          title: 'Success',
          text: 'Status updated successfully',
          color: 'success'
        })
        this.getData()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'Failed to update status',
          color: 'danger'
        })
      }
    },
    async deleteRecord(hotel) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `Are you sure you want to delete this hotel "${hotel.name}"? This action cannot be undone.`,
        accept: async () => {
          this.deletingRecord = hotel._id
          try {
            await axios.delete(`/admin/hotel/${hotel._id}`)
            this.$vs.notify({
              title: 'Success',
              text: 'Hotel deleted successfully',
              color: 'success'
            })
            this.getData()
          } catch (error) {
            this.$vs.notify({
              title: 'Error',
              text: (error.response && error.response.data && error.response.data.message) || 'Failed to delete hotel',
              color: 'danger'
            })
          } finally {
            this.deletingRecord = null
          }
        },
        acceptText: 'Delete'
      })
    }
  }
}
</script>

<style lang="scss">
.hotel-quick-cards.gurudwara-quick-cards {
  display: grid;
  grid-template-columns: repeat(var(--quick-card-count, 1), minmax(0, 1fr));
  margin: 0 0 24px;
  padding: 4px 0 20px;
  border-bottom: 1px solid var(--divider);
}

.hotel-quick-cards .gurudwara-quick-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  padding: 8px 18px;
  border: 0;
  background: transparent;
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
}

.hotel-quick-cards .gurudwara-quick-card:hover {
  opacity: 0.8;
}

.hotel-quick-cards .gurudwara-quick-card-count {
  font-size: 32px;
  line-height: 1.1;
  font-weight: 700;
}

.hotel-quick-cards .gurudwara-quick-card-copy {
  display: flex;
  align-items: center;
  gap: 4px;
}

.hotel-quick-cards .gurudwara-quick-card-label {
  font-size: 14px;
  font-weight: 500;
}
</style>
